/* global checkPromoCodes */
import { AxDropdown } from "@axess/limestone";
import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { BaseJsonResult } from "../../Models/Base";
import { BenefitTypesEnum } from "../../Models/Benefit/BenefitModel";

declare const checkPromoCodes: (codes: string) => Promise<CheckPromoCodes>;
declare const toastr: any;

@ModuleName("Benefits")
export class Benefits implements AxInit {
    private initData: InitData = {} as InitData;
    private readonly $profile = $('[data-frontoffice-view="profile"]');
    private readonly $shoppingCart = $('[data-frontoffice-view="shoppingcart"]');
    private readonly $redeem = $('[data-frontoffice-view="benefits"]');
    private readonly $modal = $('[data-benefit="modal"]');
    private readonly axLimestone = new AxLimeStone();
    private readonly request: RequestHelper = new RequestHelper();
    private readonly i18nHelper: I18nHelper = new I18nHelper();
    private readonly familyMember: AxDropdown = new AxDropdown();
    private toastOptions = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-center",
        "preventDuplicates": true,
        "showDuration": 300,
        "hideDuration": 500,
        "timeOut": 2000,
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
    };

    AxInit(init: InitData) {
        this.initData = init;
        const params = new URL(window.location.href).searchParams;
        const benefitError = params.get('benefit')
        if (benefitError == BenefitTypesEnum.Invalid.toString()) {
            Swal.fire({
                html: this.i18nHelper.GetTranslation(Translations.BenefitRedeemError),
                icon: 'info',
                confirmButtonText: this.i18nHelper.GetTranslation(Translations.Ok) ?? 'Ok',
            });
        }
        this.$profile.length > 0 && this.initProfile();
        this.$shoppingCart.length > 0 && this.initShoppingCart();
        this.$redeem.length > 0 && this.initBenefits();
    }

    initProfile() {
        const $parent: JQuery = this.$profile;
        let knowMoreButton: HTMLElement = $('<div>').get(0)!;
        sessionStorage.removeItem('benefitPromocode');

        if ($parent.find('#benefits-family-select').length > 0) {
            this.familyMember.init('#benefits-family-select', {
                searchBar: false,
                multiSelect: false,
                onSelect: (_, value) => {
                    $('#benefit-family-member').val(value);

                    $('[data-benefit="list"] .tab-pane').each((_, tabPane) => {
                        const $tabPane = $(tabPane);

                        $tabPane.find('[data-benefit-section]').each((_, section) => {
                            const $section = $(section);
                            const $cards = $section.find('[data-benefit-card]');
                            const $header = $section.find('[data-benefit-header]');

                            $cards.each((_, el) => {
                                const isMatch = (el.dataset.benefitAccount as string) === value;

                                if (isMatch) {
                                    $(el).removeClass('d-none').addClass('d-flex d-md-flex');
                                } else {
                                    $(el).removeClass('d-flex d-md-flex').addClass('d-none');
                                }
                            });

                            const visibleSectionCards = $cards.not('.d-none').length;
                            if ($header.length > 0) {
                                if (visibleSectionCards === 0) {
                                    $header.removeClass('d-flex').addClass('d-none');
                                } else {
                                    $header.removeClass('d-none').addClass('d-flex');
                                }
                            }
                        });

                        const totalVisibleCards = $tabPane.find('[data-benefit-card]:not(.d-none)').length;
                        const $emptyBanner = $tabPane.find('[data-benefit="no-benefit"]');

                        if ($emptyBanner.length > 0) {
                            if (totalVisibleCards == 0) {
                                $emptyBanner.removeClass('d-none').addClass('d-flex d-md-flex');
                            } else {
                                $emptyBanner.removeClass('d-flex d-md-flex').addClass('d-none');
                            }
                        }
                    });
                }
            });
            this.familyMember.setValue($('#benefit-family-member').val() as string);
        }

        $parent

            // Benefit Know more
            .on('click', '[data-benefit-promocode]', (e: JQuery.ClickEvent) => {
                const promoCode = $(e.currentTarget).attr('data-benefit-promocode') as string;
                knowMoreButton = e.currentTarget;
                this.axLimestone.LockButton(knowMoreButton, 'ax-btn-loading-secondary');
                const getBenefit = AxessViewer.ajaxRequest(`/Profile/GetBenefitKnowMoreModal/${promoCode}`, {}, (res: BaseJsonResult) => {
                    if (res.success) {
                        this.$modal.html(res.data);
                        this.$modal.modal?.('show');
                    }
                }, {
                    addCulturInfo: true,
                    silent: true,
                });
                getBenefit?.always?.(() => this.axLimestone.UnlockButton(knowMoreButton));
                this.$modal.on('hide.bs.modal', () => {
                    this.axLimestone.UnlockButton(knowMoreButton);
                });
            })

            // Benefit Redeem
            .on('click', '[data-benefit-redeem-promocode]', (e: JQuery.ClickEvent) => {
                const redeemButton: HTMLElement = e.currentTarget;
                const processBenefit = this.redeem(e);
                processBenefit?.always?.(() => {
                    this.$modal.modal?.('hide');
                    this.axLimestone.UnlockButton(redeemButton);
                });
            })

            // Modal Copy link
            .on('click', '[data-benefit-copy-link]', (e) => {
                const $button = $(e.currentTarget);
                const $input = $button.siblings('input');
                const value = $input.val() as string;
                navigator.clipboard.writeText(value);
                toastr.success(this.i18nHelper.GetTranslation(Translations.BenefitLinkCopied), null, this.toastOptions);
            })
            
            // As bootstrap manages tab-panel by ID, and IDs has to be unique, some exceptions have to be managed.
            .on('click', '.nav-link', (e) => {
                const tab: string = $(e.currentTarget).attr('href') as string;
                // Menu
                const $modeTabs = $(e.currentTarget).closest('ul').siblings().find('a');
                const $modeSelectedTab = $(e.currentTarget).closest('ul').siblings().find(`[href^="${tab.replace('-mobile', '')}"]`);
                // View couterparts menu selectors inactive
                $modeTabs.attr('aria-selected', 'false').removeClass('active');
                // Activate only the counterpart
                $modeSelectedTab.attr('aria-selected', 'true').addClass('active');

                // Content
                // View couterparts content selectors inactive
                $parent.find('.tab-pane').removeClass('active');
                // Activate only the counterpart
                setTimeout(() => $parent.find(`[id^="${tab.slice(1).replace('-mobile', '')}"]`).addClass('active'));
            });

    }

    initShoppingCart() {
        const benefitPromocode = sessionStorage.getItem('benefitPromocode');
        const $parent: JQuery = this.$shoppingCart;
        sessionStorage.removeItem('benefitPromocode');

        if (benefitPromocode) {
            checkPromoCodes(benefitPromocode);
        }
        
        $parent.on('click', '[data-benefit="apply"]', async (e: JQuery.ClickEvent) => {
            this.$modal.modal?.('hide');
            const $benefit = $(e.currentTarget);
            const benefit = $benefit.attr('data-benefit-promocode') as string;
            const $promoCode = $benefit.closest('.ax-shopping-cart').find('#PromoCode');
            $promoCode.val(benefit);
            const check = await checkPromoCodes(benefit);
            if (check.errorMessage) {
                $promoCode.siblings('span').remove();
                $promoCode.after(
                    $('<span>', { class: 'text-danger' }).attr('data-promo-error', '').text(check.errorMessage),
                )
            } else {
                $promoCode.val('');
                $('[data-promo-error]').remove();
            }
        });
    }

    initBenefits() {
        if (this.initData.promoCode) {
            const $parent: JQuery = this.$redeem;
            $parent.on('click', '[data-benefit-redeem-promocode]', (e: JQuery.ClickEvent) => {
                const redeemButton: HTMLElement = e.currentTarget;
                const processBenefit = this.redeem(e, '/Benefits/RedeemBenefitShared', this.initData.shoppingCartUrl, this.initData.benefitHash);
                processBenefit?.always?.(() => this.axLimestone.UnlockButton(redeemButton));
            });
        }
    }

    redeem(event: JQuery.ClickEvent, service: string = '/Profile/RedeemBenefit', redirect: string = '', hash: string = ''): JQueryXHR {
        const promoCode = $(event.currentTarget).attr('data-benefit-redeem-promocode') || this.initData.promoCode;
        const redeemButton: HTMLElement = event.currentTarget;
        this.axLimestone.LockButton(redeemButton);

        return AxessViewer.ajaxRequest(`${service}/${hash || promoCode}`, {}, (res: BaseJsonResult) => {
            this.$modal.modal?.('hide');
            if (res.success && res.data?.url && res.data?.promoCode) {
                if (res.data?.promoCode) {
                    sessionStorage.setItem('benefitPromocode', res.data.promoCode);
                }
                window.location.href = this.request.getFullUrl(res.data.url);
            }
            if (!res.success) {
                Swal.fire({
                    title: res.errorNo != 0 ? `${this.i18nHelper.GetTranslation(Translations.SomethingWrong)}!` : '',
                    html: res.message,
                    icon: res.errorNo != 0 ? 'error' : 'info',
                    confirmButtonText: this.i18nHelper.GetTranslation(Translations.Ok) ?? 'Ok',
                }).then((result) => {
                    if (result.isConfirmed && redirect) {
                        window.location.href = this.request.getFullUrl(redirect);
                    }
                });
            }
            return res;
        }, {
            addCulturInfo: true,
            silent: true,
        });
    }
}

interface CheckPromoCodes {
    discountFound: boolean;
    errorMessage: string;
    isPromocodeApplied: boolean;
    promocodes: string[];
    success: boolean;
    view: string;
}

interface InitData {
    promoCode: string;
    shoppingCartUrl: string;
    benefitHash: string;
}